import axios from "@/utils/axios";

export default async function (establishment) {
  const response = await axios.post(`/establishment-presale`, establishment);

  const establishmentCreated = response.data;

  return establishmentCreated;
}
